<template>
  <el-table
    :data="tableData"
    class="egl-table"
    stripe
    :span-method="spanMethod"
    :cell-class-name="setCellClassName"
  >
    <el-table-column :label="$locale('accountPayable.requestName')">
      <template slot-scope="scope">
        <!-- <el-select v-model="scope.row.invoiceId" @change="selectAccountReceivable(scope.$index)">
          <el-option :value="item.id" :label="item.name" v-for="item in accountReceivableList" :key="item.id"></el-option>
        </el-select> -->
        <!-- <remote-select
          type="invoice"
          v-model="scope.row.invoiceId"
          :formValue.sync="scope.row.invoiceId"
          actionType="create"
          @change="selectAccountReceivable(scope.$index)"
          :isMultiple="false"
        /> -->
        <RemoteSelectV2
          ref="selectV2"
          type="invoice"
          :list="accRList"
          :fields="getApiKeysField()"
          v-model="scope.row.invoiceId"
          :isMultiple="false"
          :formValue.sync="scope.row.invoiceId"
          @change="selectAccountReceivable(scope.$index)"
          @setList="arr => accRList = arr"
        />
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.billingStatement')">
      <template slot-scope="scope">
        <el-select v-model="scope.row.offsetDetailId" @change="selectOffsetDetailId(scope.$index)">
          <el-option :value="item.id" :label="item.name" v-for="item in column2_options[scope.$index]" :key="item.id"></el-option>
        </el-select>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.client')" prop="clientName"></el-table-column>

    <el-table-column :label="$locale('accountPayable.th.requestDeadDate')">
      <template slot-scope="scope">
        <div v-if="scope.$index < tableData.length - 1">
          <span v-if="scope.row.invoiceId">{{ $moment(scope.row.requestDeadDate).format("YYYY-MM-DD") }}</span>
        </div>
        <div v-else>{{ scope.row.requestDeadDate }}</div>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.accountsReceivableBalance')">
      <template slot-scope="scope">
        <span v-if="typeof(scope.row.actualAmountResidual) == 'number'">{{ scope.row.actualAmountResidual.toLocaleString() }}</span>
        <span v-else>{{ scope.row.actualAmountResidual }}</span>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.offsetAmount')">
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.payAmount"
          @input="setPayAmount(scope.$index, true)"
          @blur="setPayAmount(scope.$index, false)"
          v-if="scope.$index < tableData.length - 1"
        ></el-input>
        <span v-else>{{ scope.row.payAmount.toLocaleString() }}</span>
      </template>
    </el-table-column>

    <el-table-column :label="$locale('accountPayable.afterOffset')">
      <template slot-scope="scope">
        <span v-if="typeof(scope.row.minusResidualAmount) == 'number'" :class="scope.row.minusResidualAmount < 0 ? 'red-text' : ''">{{ scope.row.minusResidualAmount.toLocaleString() }}</span>
        <span v-else :class="scope.row.minusResidualAmount < 0 ? 'red-text' : ''">{{ scope.row.minusResidualAmount }}</span>
      </template>
    </el-table-column>

    <el-table-column width="120">
      <template slot-scope="scope">
        <div v-if="scope.$index < tableData.length - 1">
          <el-button class="handle-btn egl-btn-white-gray-border" v-if="tableData.length > 2" @click="removeRow(scope.$index)">
            <i class="el-icon-minus"></i>
          </el-button>
          <el-button class="handle-btn egl-btn-white-gray-border" v-if="scope.$index == tableData.length - 2" @click="addRow">
            <i class="el-icon-plus"></i>
          </el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { createOffsetInvoiceTableTr, getKeyNames } from "@/assets/js/accountPayable.js";
import { getAccountReceivableDetail } from "@/helpers/service/api/accountPayable.js";
import { mapState } from "vuex";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getApiKeysField } from "@/utils/getApiKeys";

export default {
  name: "AccountPayablePaymentOtherOffsetTable1",
  inject: [ "accReceivableList" ],
  props: {
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      tableData: [],
      column2_options: [],
      getApiKeysField,
      accRList: [],
    };
  },
  computed: {
    ...mapState("app", { brandId: state => state.brandId }),
    // ...mapState("api", { accountReceivableList: state => state.invoiceList }),
    ...mapState("accountPayable", { offsetHistory: state => state.offsetHistory }),
    accountReceivableList() {
      return this.accReceivableList();
    }
  },
  methods: {
    setProp() {
      const brandId = this.brandId;
      let lastTr_actualAmountResidual = 0;
      let lastTr_payAmount = 0;
      let lastTr_minusResidualAmount = 0;

      let tableData = [ ...this.tableData ];
      let targetTable = [];

      for (let i = 0; i < tableData.length - 1; i++) {
        if (tableData[i].invoiceId && tableData[i].payAmount !== "") {
          lastTr_actualAmountResidual += tableData[i].actualAmountResidual;
          lastTr_payAmount += parseInt(tableData[i].payAmount) || 0;
          lastTr_minusResidualAmount += tableData[i].minusResidualAmount;
          targetTable.push({ ...tableData[i], brandId });
        }
      }

      this.tableData[this.tableData.length - 1].actualAmountResidual = lastTr_actualAmountResidual;
      this.tableData[this.tableData.length - 1].payAmount = lastTr_payAmount;
      this.tableData[this.tableData.length - 1].minusResidualAmount = lastTr_minusResidualAmount;
      this.$emit("setOffset", "invoice", targetTable, lastTr_payAmount);
    },
    async selectAccountReceivable(index) {
      const invoiceId = this.tableData[index].invoiceId;
      let keyNames = [];
      let column2_options = [ ...this.column2_options ];
      let payAmount = this.tableData[index].payAmount || 0;

      column2_options[index] = [];

      const accountReceivableObj = (await getAccountReceivableDetail({ id:invoiceId })).data;

      keyNames = getKeyNames(accountReceivableObj.operationType);
      console.log(keyNames);
      keyNames.map(keyName => {
        if (accountReceivableObj.targetSourceList[keyName] && accountReceivableObj.targetSourceList[keyName].detail.length > 0) {
          accountReceivableObj.targetSourceList[keyName].detail.map(item => {
            column2_options[index].push({
              id: item.uuid,
              name: item.showName,
            });
          });
        }
      });
      this.tableData[index].requestName = accountReceivableObj.name;
      this.tableData[index].clientId = accountReceivableObj.clientId;
      this.tableData[index].clientName = accountReceivableObj.clientInfo.name;
      this.tableData[index].offsetDetailId = "";
      this.tableData[index].offsetDetail = "";
      this.tableData[index].requestDeadDate = accountReceivableObj.requestDeadDate;
      this.tableData[index].actualAmountResidual = accountReceivableObj.actualAmountResidual;
      this.tableData[index].minusResidualAmount = accountReceivableObj.actualAmountResidual - payAmount;
      this.column2_options = column2_options;
      this.setProp();
    },
    selectOffsetDetailId(index) {
      let showName = "";

      for (let i = 0; i < this.column2_options[index].length; i++) {
        if (this.column2_options[index][i].id == this.tableData[index].offsetDetailId) {
          showName = this.column2_options[index][i].name;
          break;
        }
      }

      this.tableData[index].offsetDetail = showName;
      this.setProp();
    },
    spanMethod({rowIndex, columnIndex}) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };
      let dataLength = this.tableData.length;

      if (rowIndex == dataLength - 1) {
        if (columnIndex == 3) {
          obj.colspan = 4;
        } else if (columnIndex >= 4) {
          obj.colspan = 1;
        } else {
          obj.colspan = 0;
        }
      }

      return obj
    },
    setCellClassName({rowIndex, columnIndex}) {
      if (columnIndex == 4 || columnIndex == 5 || columnIndex == 6 || rowIndex == this.tableData.length - 1) {
        return "ta-r"
      }
    },
    setPayAmount(index, isInput = true) {
      let inputNum = this.tableData[index].payAmount;
      let actualAmountResidual = this.tableData[index].actualAmountResidual || 0;
      let minusResidualAmount = 0;
      let num = inputNum.toString().replace(/[^\d-]/g, "");

      inputNum = parseInt(inputNum.toString().replace(/[^\d-]/g, "")) || 0;
      minusResidualAmount = actualAmountResidual - inputNum;

      num = isInput ? num : inputNum;

      this.tableData[index].payAmount = num;
      this.tableData[index].minusResidualAmount = minusResidualAmount;

      this.setProp();
    },
    addRow() {
      let rowItem = createOffsetInvoiceTableTr();
      let tableData = [ ...this.tableData ];

      tableData.splice(tableData.length - 1, 0, rowItem);
      this.tableData = tableData;
      this.column2_options = [ ...this.column2_options, [] ];
    },
    removeRow(index) {
      let tableData = [ ...this.tableData ];
      let column2_options = [ ...this.column2_options ];

      tableData.splice(index, 1);
      column2_options.splice(index, 1);

      this.tableData = tableData;
      this.column2_options = column2_options;
      this.setProp();
    },
  },
  mounted() {
    this.accRList = this.$_.cloneDeep(this.accountReceivableList);
    let lastTr = {
      requestDeadDate: this.$locale("global.total"),
      actualAmountResidual: 0,
      payAmount: 0,
      minusResidualAmount: 0,
    };
    let trs = [];
    let column2_options = [];

    if (this.offsetHistory.invoice && this.offsetHistory.invoice.length > 0) {
      this.offsetHistory.invoice.map(async (item, index) => {
        let keyNames = [];
        const accountReceivableObj = (await getAccountReceivableDetail({ id:item.invoiceId })).data;

        keyNames = getKeyNames(accountReceivableObj.operationType);
        column2_options[index] = [];

        keyNames.map(keyName => {
          if (accountReceivableObj.targetSourceList[keyName] && accountReceivableObj.targetSourceList[keyName].detail.length > 0) {
            accountReceivableObj.targetSourceList[keyName].detail.map(secItem => {
              column2_options[index].push({
                id: secItem.uuid,
                name: secItem.showName,
              });
            });
          }
        });

        trs.push({ ...item });

        lastTr.actualAmountResidual += item.actualAmountResidual;
        lastTr.payAmount += item.payAmount;
        lastTr.minusResidualAmount += item.minusResidualAmount;
      });

      this.$emit("setOffset", "invoice", trs, lastTr.payAmount);
    } else {
      trs.push(createOffsetInvoiceTableTr());
      column2_options.push([]);
    }

    this.tableData = [ ...trs, lastTr ];
    this.column2_options = column2_options;
    // get invoice list
    const ids = this.tableData.filter(item => item.invoiceId);
    this.$nextTick(() => {
      if (ids.length === 0) this.$refs["selectV2"].page++;
    });
  },
  components: {
    RemoteSelectV2
  },
};
</script>
